<div class="complete-page">
  <div class="complete-page-inner">
    <span class="completed-page-check material-icons">check_circle</span>
    <h2>Completed Wizard!</h2>
  </div>
</div>
